export const TOURNAMENT = {
  BYE_ID: "BYE",
  CHAMPION_CUP_NAME: "Champion",
  BOULE_NAMES: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  BYE_NAME: "--- BYE ---"
};
